import { captureException } from '@sentry/react';
import axios from 'axios';

import { toApiServiceError } from '@/services/http/errors';

import { acceptAccountResponse, authorizedAxiosInstanceConfig, bindAccountRequest } from './authorized';

export const authorizedStreamingAxiosInstance = axios.create({
    ...authorizedAxiosInstanceConfig,
    responseType: 'stream',
});

// authorizedAxiosInstance.interceptors.request.use((config) => {
//     console.log(`[Request] ${config.method?.toUpperCase()} ${config.url}`);

//     return config;
// });

authorizedStreamingAxiosInstance.interceptors.request.use(bindAccountRequest);
authorizedStreamingAxiosInstance.interceptors.response.use(acceptAccountResponse);

authorizedStreamingAxiosInstance.interceptors.response.use(
    (response) => {
        // Successful response
        return response;
    },
    (error) => {
        const apiError = toApiServiceError(error);

        captureException(apiError);

        return Promise.reject(apiError);
    },
);
